
import { Vue, Component } from 'vue-property-decorator'
import PromoteRevalidation from '../../components/popup/promote-revalidation.vue'
import store from '@/store';

@Component({
  name: 'Accountpending',
  components: {
    PromoteRevalidation
  }
})
export default class AccountPending extends Vue {
  isNeedToRevalidate = true;
  created() {
    store.dispatch('account/loadAccountList');
  }
}
